import type { Setting } from './../types';
import type { FetchListParams } from './index';
import CommonApi from './../commonApi';

type SettingParams = {
  settingKey?: string;
};

type FetchSetting = (
  params?: FetchListParams<SettingParams>
) => Promise<Setting>;

const setting = new CommonApi<Setting, SettingParams>(
  'settings',
  'Настройки системы'
);

const fetchSetting = setting.fetch as unknown as FetchSetting;

export default {
  ...setting,
  fetch: fetchSetting,
};
